import { render, staticRenderFns } from "./verifyOtp.vue?vue&type=template&id=6bed6f7c&"
import script from "./verifyOtp.vue?vue&type=script&lang=js&"
export * from "./verifyOtp.vue?vue&type=script&lang=js&"
import style0 from "./verifyOtp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports